/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MenuService {
    /**
     * Menu open/closed state.
     */
    public menuOpen: Subject<boolean> = new Subject<boolean>();

    /**
     * Force close the menu
     */
    public menuClose: Subject<boolean> = new Subject<boolean>();

    /**
     * Track the menu items.
     */
    public menuStateLookup: any = {};

    /**
     * Track the groups by level.
     */
    public menuGroupsLookup: any = {};

    /**
     * Set the selected menu item.
     */
    public selectedMenuItem: any = {};

    /**
     * Store menu closed state.
     */
    public menuClosed: boolean = false;

    /**
     * Menu 3.0 variable
     */
    public menuIsOpen: Subject<boolean> = new Subject<boolean>();

    /**
     * Menu 3.0 variable
     */
    public menuState: boolean = true;

    /**
     * Menu 3.0 variable for menu type
     */
    public menuTypeIsHover: Subject<boolean> = new Subject<boolean>();

    constructor() {
        this.menuIsOpen.subscribe(
            (state: boolean): void => {
                this.menuState = !state;
            }
        );
    }
}
